export const baseUrl = process.env.VUE_APP_API_BASE_URL || "https://api.bhlbd.com/api/v1";
